@if(isLanding){
<div
    class="my-8 my-lg-13 mx-xl-0 p-5 p-md-15  evisa-bg-white rounded-5 contact-us-landing d-flex flex-column justify-content-center">
    <div class="px-md-8">
        <p class="heading-2 ibm-semibold pb-2 linear-gradient-text pb-5">{{ 'FOOTER.CONTACT_US' | translate }}</p>
        <div class="d-flex row justify-content-between">
            <div class="col-12 col-lg-6">
                <form [formGroup]="contactForm" autocomplete="off">
                    <div class=" row">
                        <div>
                            <div class="form-floating">
                                <input class="form-control px-4" type="text" autocomplete="off"
                                    [placeholder]="'CREATE_VISA.PERSONAL_INFO.NAME' | translate"
                                    formControlName="contactUsFirstName" appAlphabetsAndSpaceOnly />
                                <label class="mandatory">{{'CREATE_VISA.PERSONAL_INFO.NAME' | translate}}</label>
                                <app-validation-message [formSubmission]="isSubmitted"
                                    [control]="contactForm.get('contactUsFirstName')"></app-validation-message>
                            </div>
                        </div>
                        <div>
                            <div>
                                <div class="form-floating mt-4">
                                    <input class="form-control px-4" type="text" autocomplete="off"
                                        [placeholder]="'EMAIL_VERIFICATION.EMAIL' | translate"
                                        formControlName="contactUsEmail" appNoArabicInput />
                                    <label class="mandatory">{{ "EMAIL_VERIFICATION.EMAIL" | translate }}</label>
                                    <app-validation-message [formSubmission]="isSubmitted"
                                        [control]="contactForm.get('contactUsEmail')"></app-validation-message>
                                </div>
                            </div>
                            <div>
                                <div class="form-floating mt-4">
                                    <textarea class="form-control"
                                        [placeholder]="'CREATE_VISA.CONTACT_INFO.QUERY_LABEL' | translate"
                                        autocomplete="off" formControlName="contactUsMessage"
                                        style="height: 130px;"></textarea>
                                    <label class="mandatory">{{ 'CREATE_VISA.CONTACT_INFO.QUERY_LABEL' | translate
                                        }}</label>
                                    <app-validation-message [formSubmission]="isSubmitted"
                                        [control]="contactForm.get('contactUsMessage')"></app-validation-message>
                                </div>
                            </div>
                            <button class="btn-1 w-50 p-2 mt-4" type="button"
                                data-wizard-next-btn="data-wizard-next-btn"
                                (click)="contactUs()">{{"INQUIRIES.SUBMIT"|translate}}</button>
                        </div>

                        @if(showCaptcha){
                        <app-captcha (allowAccess)="handleRecaptchaResponse($event)"></app-captcha>
                        }

                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
}
@else {
<div class="my-8 my-lg-13 mx-xl-0 p-5 px-xl-7 py-xl-8 evisa-bg-white rounded-5">
    <!-- <p class="heading-2 ibm-semibold pb-2 linear-gradient-text">{{ 'CONTACT_US.TITLE' | translate }}</p> -->
    <p class="heading-2 ibm-semibold pb-2 linear-gradient-text">{{ 'FOOTER.CONTACT_US' | translate }}</p>

    <div class="content-wrapper my-2 mb-5">
        <p class="text-2 ibm-medium line-7 text-blue-2">{{ 'CONTACT_US.INTRO' | translate }}</p>
    </div>

    <div class="d-flex row justify-content-between">
        <div class="col-12 col-lg-6">
            <!-- <p class=" heading-3 ibm-medium pb-2 linear-gradient-text">{{ 'CONTACT_US.ADDRESS.TITLE' | translate }}</p>
            <div class="content-wrapper my-2">
                <p class="text-2 ibm-medium text-blue-2 line-7">{{ 'CONTACT_US.ADDRESS.DETAILS' | translate }}</p>
            </div>
            <p class=" heading-3 ibm-medium pb-2 linear-gradient-text">{{ 'CONTACT_US.WORKING_HOURS.TITLE' | translate
                }}</p>
            <div class="content-wrapper my-2">
                <p class="text-2 ibm-medium text-blue-2 line-7">{{ 'CONTACT_US.WORKING_HOURS.DETAILS' | translate }}</p>
            </div>
            <p class="heading-3 ibm-medium pb-3 linear-gradient-text">{{ 'FOOTER.CONTACT_US' | translate }}</p> -->
            <form [formGroup]="contactForm" autocomplete="off">
                <div class="">
                    <div>
                        <div class="form-floating">
                            <input class="form-control px-4" type="text" autocomplete="off"
                                [placeholder]="'CREATE_VISA.PERSONAL_INFO.NAME' | translate"
                                formControlName="contactUsFirstName" appAlphabetsAndSpaceOnly />
                            <label class="mandatory">{{'CREATE_VISA.PERSONAL_INFO.NAME' | translate}}</label>
                            <app-validation-message [formSubmission]="isSubmitted"
                                [control]="contactForm.get('contactUsFirstName')"></app-validation-message>
                        </div>
                    </div>
                    <div>
                        <div>
                            <div class="form-floating mt-4">
                                <input class="form-control px-4" type="text" autocomplete="off"
                                    [placeholder]="'EMAIL_VERIFICATION.EMAIL' | translate"
                                    formControlName="contactUsEmail" appNoArabicInput />
                                <label class="mandatory">{{ "EMAIL_VERIFICATION.EMAIL" | translate }}</label>
                                <app-validation-message [formSubmission]="isSubmitted"
                                    [control]="contactForm.get('contactUsEmail')"></app-validation-message>
                            </div>
                        </div>
                        <div>
                            <div class="form-floating mt-4">
                                <textarea class="form-control"
                                    [placeholder]="'CREATE_VISA.CONTACT_INFO.QUERY_LABEL' | translate"
                                    autocomplete="off" formControlName="contactUsMessage"
                                    style="height: 100px;"></textarea>
                                <label class="mandatory">{{ 'CREATE_VISA.CONTACT_INFO.QUERY_LABEL' | translate
                                    }}</label>
                                <app-validation-message [formSubmission]="isSubmitted"
                                    [control]="contactForm.get('contactUsMessage')"></app-validation-message>
                            </div>
                        </div>
                        <button class="btn-1 w-50 p-2 mt-4" type="button" data-wizard-next-btn="data-wizard-next-btn"
                            (click)="contactUs()">{{"INQUIRIES.SUBMIT"|translate}}</button>
                    </div>
                    @if(showCaptcha){
                    <app-captcha (allowAccess)="handleRecaptchaResponse($event)"></app-captcha>
                    }
                </div>
            </form>
        </div>
        <!-- <div class="col-12 col-lg-6 mt-5">

            <div
                style="position: relative; padding-bottom: 50%; height: 0; max-width: 500px; margin: 0 auto; overflow: hidden; border-radius: 15px; ">
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1189.7193709447272!2d47.9598744!3d29.2594502!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3fcf99000c8c4199%3A0x4f506a73d208b291!2zRWxlY3Ryb25pYyBTZXJ2aWNlcyBNYW5hZ2VtZW50INil2K_Yp9ix2Kkg2KfZhNiu2K_Zhdin2Kog2KfZhNin2YTZg9iq2LHZiNmG2YrYqQ!5e1!3m2!1sen!2skw!4v1728368786602!5m2!1sen!2skw"
                    style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; border: 0;"
                    allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
            </div>
        </div> -->
    </div>
</div>
}